module.exports = __webpack_public_path__ + "82c3a6e2c1edc45f4f7bb9a8f05d26a7.ttf";